import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core';
// import Button from '@material-ui/core/Button';
import {
  EXIMBAY_CALLBACK,
  EXIMBAY_MID,
  EXIMBAY_PAY,
  EXIMBAY_SECRETKEY,
  EXIMBAY_STATUS_CALLBACK,
  KICC_APPROVAL,
  KICC_MID,
  KICC_PAY,
  PG_API_URL,
  PG_REDIRECT,
} from '../constatns';

import AdminTopbar from './AdminTopbar';
import AdminFooter from './AdminFooter';
import KeyDates from './KeyDates';
import Popout from 'react-popout-new';
import * as querystring from 'querystring';
import axios from 'axios';
import moment from 'moment';

const styles = (theme) => ({
  root: {
    minHeight: 800,
  },
});

class DashboardPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      matches: window.matchMedia('(max-width:600px)').matches,
      openPay: false,
    };
    this.receiveMessage = this.receiveMessage.bind(this);
  }

  componentDidMount() {
    // 결제 테스트 시 아래 리스너 추가해주세요.
    // window.addEventListener('message', this.receiveMessage);
  }

  receiveMessage(event) {
    // console.log(event.data);
    if (event.data.payResult) {
      const result = querystring.parse(localStorage.getItem('payResult').replace('?', ''));
      console.log(result);
      if (this.state.pg === 'eximbay') {
      } else {
        if (localStorage.getItem('payResult')) {
          const data = {
            mallId: KICC_MID,
            shopTransactionId: '20210326090046',
            authorizationId: result.authorizationId,
            shopOrderNo: result.shopOrderNo,
            approvalReqDate: moment().format('YYYYMMDD'),
          };
          axios.post(KICC_APPROVAL, data).then((res) => {
            console.log(res);
            alert('Success');
          });
        }
      }
    }
  }

  handlePay(_pg_) {
    this.setState({ pg: _pg_ });
    if (_pg_ === 'eximbay') {
      const data = {
        ver: 230,
        mid: EXIMBAY_MID,
        secretKey: EXIMBAY_SECRETKEY,
        returnurl: EXIMBAY_CALLBACK,
        statusurl: EXIMBAY_STATUS_CALLBACK,
        paymethod: 'P000',
        txntype: 'PAYMENT',
        ostype: 'P',
        displaytype: 'P',
        lang: 'EN',
        ref: 'demo20170418202020',
        param1: PG_REDIRECT,
      };
      data['amt'] = '1.0';
      data['buyer'] = 'Buyer';
      data['cur'] = 'USD';
      data['email'] = 'zesthj@gmail.com';
      data['item_0_product'] = 'Product Name';
      data['item_0_quantity'] = '1';
      data['item_0_unitPrice'] = '1';

      this.setState({ openPay: true, openPayUrl: EXIMBAY_PAY + '?' + querystring.stringify(data) });
      // this.setState({ openPay: true, openPayUrl: 'http://localhost:3001/#/payResult' });
    } else {
      const data = {
        mallId: KICC_MID,
        payMethodTypeCode: '11',
        currency: '00',
        amount: 1004,
        clientTypeCode: '00',
        returnUrl: PG_API_URL + '/kicc/callback',
        deviceTypeCode: 'pc',
        shopOrderNo: '20210326085908',
        orderInfo: {
          goodsName: '예시 상품명',
        },
        shopValueInfo: {
          value1: PG_REDIRECT,
        },
      };
      axios.post(KICC_PAY, data).then((res) => {
        console.log(res);
        this.setState({ openPay: true, openPayUrl: res.data.authPageUrl });
      });
    }
  }

  handleClose() {}

  payCallback(response) {
    const {
      success,
      //  merchant_uid,
      error_msg,
    } = response;
    console.log(response);

    if (success) {
      alert('결제 성공');
    } else {
      alert(`결제 실패: ${error_msg}`);
    }
  }

  render() {
    const { classes } = this.props;
    return (
      <Grid item xs={12}>
        <CssBaseline />
        <AdminTopbar MIdx={0} SIdx={0} />
        <Grid container alignItems={'stretch'} direction="column" style={{ padding: 16 }} className={classes.root}>
          <Grid item xs={12}>
            <Grid container alignItems={'center'} justifyContent={'center'}>
              <Grid item xs={8}>
                <h1>Dashboard</h1>
              </Grid>
            </Grid>
            {<KeyDates />}

            {/*    <Grid container alignItems={'center'} justifyContent={'center'} style={{ marginTop: 30 }}>*/}
            {/*      <Grid item xs={8}>*/}
            {/*        <h2>결제 테스트 </h2>*/}
            {/*      </Grid>*/}
            {/*    </Grid>*/}
            {/*    <Grid item>*/}
            {/*      <Grid container alignItems={'center'} justifyContent={'flex-start'}>*/}
            {/*        <Grid item xs={2}>*/}
            {/*          {' '}*/}
            {/*        </Grid>*/}
            {/*        <Grid item xs={10}>*/}
            {/*          <Button variant={'outlined'} color={'primary'} style={{ marginRight: 10 }} onClick={() => this.handlePay('eximbay')}>*/}
            {/*            TEST - eximbay*/}
            {/*          </Button>*/}
            {/*          <Button*/}
            {/*            variant={'outlined'}*/}
            {/*            color={'primary'}*/}
            {/*            style={{ marginRight: 10 }}*/}
            {/*            onClick={() => {*/}
            {/*              this.handlePay('html5_inicis');*/}
            {/*            }}*/}
            {/*          >*/}
            {/*            TEST - KG이니시스*/}
            {/*          </Button>*/}
            {/*        </Grid>*/}
            {/*      </Grid>*/}
            {/*    </Grid>*/}
          </Grid>
        </Grid>
        <AdminFooter />
        {this.state.openPay ? (
          <Popout url={this.state.openPayUrl} title="PRS2021-PAY" onClosing={this.handleClose} options={{ width: 850, height: 800 }} />
        ) : null}
      </Grid>
    );
  }
}

export default withStyles(styles, { withTheme: true })(DashboardPage);
